/**
 * tiktokPixel.js — Capa segura de eventos TikTok Pixel
 *
 * - Si window.ttq no está disponible (pixel no cargado, bloqueador de ads,
 *   SSR, entorno de test), todas las funciones son no-op silenciosos.
 * - Nunca lanza excepciones ni rompe el flujo de la app.
 * - Activar: setear REACT_APP_TIKTOK_PIXEL_ID en Netlify → rebuild.
 * - Activo para todos los usuarios desde el 02-Jun-2026.
 */

function ttq() {
  return typeof window !== 'undefined' ? window.ttq : null;
}

// Registra el evento en window.__ttqEvents para el panel de debug del admin.
function logEvent(name, params) {
  try {
    if (typeof window === 'undefined') return;
    if (!window.__ttqEvents) window.__ttqEvents = [];
    window.__ttqEvents.push({ name, params, ts: new Date().toISOString() });
  } catch (_) {}
}

/**
 * PageView — se dispara automáticamente al cargar el pixel.
 * Llamar si necesitas forzar re-track en navegación SPA.
 */
export function trackPageView() {
  try {
    ttq()?.page?.();
    logEvent('PageView', {});
  } catch (_) {}
}

/**
 * CompleteRegistration — nuevo usuario completó el formulario de registro.
 * Dispara después del submit exitoso en RegisterForm.jsx.
 * Permite a TikTok Ads optimizar para "personas que se registran".
 */
export function trackRegistration() {
  try {
    const params = { contents: [{ content_name: 'IntelliVerseOne_Trial' }], value: 0, currency: 'USD' };
    ttq()?.track?.('CompleteRegistration', params);
    logEvent('CompleteRegistration', params);
  } catch (_) {}
}

/**
 * Subscribe — usuario completó una compra de plan Pro o Pro+.
 * Llamar después de confirmar el webhook de Freemius.
 * @param {string} plan  'Pro' | 'Pro+'
 * @param {number} value  precio en USD (5.79 | 9.79)
 */
export function trackSubscription(plan = 'Pro', value = 5.79) {
  try {
    const params = { contents: [{ content_name: `IntelliVerseOne_${plan}` }], value, currency: 'USD' };
    ttq()?.track?.('Subscribe', params);
    logEvent('Subscribe', params);
  } catch (_) {}
}

/**
 * ViewContent — usuario vio la página de planes (/plans).
 * Ayuda a optimizar campañas de "interés en upgrade".
 */
export function trackViewPlans() {
  try {
    const params = { contents: [{ content_name: 'Plans_Page' }], value: 0, currency: 'USD' };
    ttq()?.track?.('ViewContent', params);
    logEvent('ViewContent', params);
  } catch (_) {}
}

export function trackDemoLead(demo = 'study') {
  try {
    const params = {
      content_id: `iv1_demo_${demo}`,
      content_type: 'product',
      contents: [{ content_id: `iv1_demo_${demo}`, content_name: `IntelliVerseOne_Demo_${demo}` }],
      value: 0,
      currency: 'USD',
    };
    ttq()?.track?.('Lead', params);
    logEvent('Lead', params);
  } catch (_) {}
}

export function trackDemoViewContent(demo = 'study') {
  try {
    const params = {
      content_id: `iv1_demo_${demo}`,
      content_type: 'product',
      contents: [{ content_id: `iv1_demo_${demo}`, content_name: `IntelliVerseOne_Demo_${demo}` }],
      value: 0,
      currency: 'USD',
    };
    ttq()?.track?.('ViewContent', params);
    logEvent('ViewContent', params);
  } catch (_) {}
}
